import React, { useState } from "react";
import { useQuery } from "react-query";
import { deleteStores, getStoreBranches, updateStore } from "../../../MyApi/stores";
import DataTable from "../../UI/table/DataTable";
import LoadingSpinner from "../../UI/spinner";
import { useNavigate, useLocation } from "react-router-dom";
import StatusBadge from "../../UI/statusBadge";
import TableActions from "../../UI/table/TableActions";
import i18next from "i18next";

const BranchInfo = ({ id ,name }) => {
  const [current_page,setCurrentPage]=useState(1)
  const location = useLocation();
  const { data, isLoading } = useQuery(["getStoreBranches", id, current_page], () =>
    getStoreBranches(id, current_page)
  );
  const storeBranches = data?.data?.branches || [];
   const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;
  const navigate =useNavigate()
  const branchColumns = [
    { label: " رقم الفرع", accessor: "id" },
    { label: "اسم الفرع", accessor: "name" },

    { label: "العنوان", accessor: "address" },
    { label: "ساعات العمل", accessor: "working_hours" },
    { label: "رقم الجوال", accessor: "phone" },  
    { label: "نشط",     render: (row) => <StatusBadge  status={row.is_active ?"active":""}/>,},
    { label: "الطلبات", accessor: "count_orders" },    
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          viewPermission={"view_store"}
          editPermission={"update_store"}
          deletePermission={"delete_store"}
          show={`${process.env.PUBLIC_URL}/store/${row.id}`}
          edit={`${process.env.PUBLIC_URL}/stores/edit/${row.id}`}
          deleteFn={deleteStores}
          id={row.id}
          mutationKey={"deleteStore"}
          togglePermission={"update_store"}
          toggleMutationKey={"toggle-update-store"}
          queryKey={"getStoreBranches"}
          toggleFn={(id, status) => updateStore({store:{is_active:status },"_method":"PUT",lang:i18next.language},id)}
          is_active={row.is_active}
        />
      ),
    },
  ];   
  const onAddClick =()=>{
    console.log(' location.pathname + location.search',  location.pathname + location.search)
  navigate(`${process.env.PUBLIC_URL}/stores/store?store_id=${id}&store_name=${name}&type=branch`, { 
    state: { from: location.pathname + location.search    , tab:"branches"} 

  })
  }

  return (
    <div>   
      <DataTable
       onAddClick={onAddClick}
       createPermission={"view_store"}
        actionLabel={"إضافة فروع"}
        title={"الفروع"}
        data={storeBranches}
        columns={branchColumns}
        isLoading={isLoading}     
        totalItems={totalItems} 
        itemsPerPage={lastPage}
        currentPage={current_page}
        setCurrentPage={setCurrentPage}
      />

      
    </div>
  );
};

export default BranchInfo;
